<template>
  <CustomTooltip :text="tooltip">
    <MessageActionButton
      :disabled="isLoading"
      @click="toggleAudio"
    >
      <i
        v-if="isLoading"
        class="tw:i-fas-spinner tw:animate-spin"
      />
      <i
        v-else-if="playing"
        class="tw:i-fas-circle-stop"
      />
      <i
        v-else
        class="tw:i-fas-volume"
      />
    </MessageActionButton>
  </CustomTooltip>
</template>

<script setup>
import { computed } from 'vue'
import MessageActionButton from '@/components/common/message/message-action-button.vue'
import CustomTooltip from '@/components/custom-tooltip.vue'
import constants from '@/generated/constants.js'
import { useSynthesize } from '../../video/create/text-to-speech/use-text-to-speech.js'
import { useProvidePreviewVoice } from '../preview-voice/use-preview-voice.js'

const props = defineProps({
  message: {
    type: String,
    required: true,
  },
})

const { isLoading, synthesize } = useSynthesize()
const { audioContent, audioRef, playing } = useProvidePreviewVoice()
const tooltip = computed(() => playing.value ? 'Click to pause the audio' : 'Click to play the audio')

async function toggleAudio() {
  try {
    audioRef.value?.pause()

    if (playing.value) {
      return
    }

    if (!audioContent.value) {
      audioContent.value = await synthesize({
        input: props.message,
        voice: constants.App_Extensions_OpenAi_Enums_Voice.ALLOY,
      })
    }

    await audioRef.value.play()
  }
  catch (err) {
    if (err.response?.status === 422) {
      await window.SwalTimer.fire({
        icon: 'error',
        title: 'Error',
        text: Object.values(err.response.data)[0][0],
      })
    }
  }
}
</script>
